<template>
  <v-card :loading="loading">

    
    <v-alert v-if="erros" type="error">
      {{ erros }}
    </v-alert>
    <v-tabs
      v-model="tabPrincipal"
      background-color="success"
      dark
    >
      <v-tab>Cliente</v-tab>
      <v-tab v-if="formCliente.id">Arquivos</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabPrincipal">  

      <!-- INI - TAB CADASTRO DO CLIENTE -->         
      <v-tab-item>
        <v-container>
          <v-form
            ref="formCliente"
            autocomplete="disabled"
          >
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-mask="['###.###.###-##']"
                  v-model="$v.formCliente.pessoa.nr_cpfcnpj.$model"
                  :error-messages="validacaoForm($v.formCliente.pessoa.nr_cpfcnpj, 'CPF')"
                  label="Cpf"
                  @change="buscaClientePorCpfCnpj($v.formCliente.pessoa.nr_cpfcnpj.$model)"
                  :loading="loadingBuscarCpfCnpj"
                  :disabled="formCliente.id > 0"
                  autocomplete="nope"
                ></v-text-field>

              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model.lazy="$v.formCliente.pessoa.nm_pessoa.$model" 
                  :error-messages="validacaoForm($v.formCliente.pessoa.nm_pessoa, 'Nome')"
                  :counter="60"
                  label="Nome"
                  v-remove-acentos="'uppercase'"
                  autocomplete="nope"
                  v-on:change.native="validaAlteracao($event)"
                >
                </v-text-field>
              </v-col> 
            </v-row> 

            <div v-if="formCliente.pessoa">
              <pessoa-fisica ref="formPessoaFisica" :pessoaFisica="formCliente.pessoa.pessoa_fisica"></pessoa-fisica>
            </div>

            <v-tabs
              v-model="tab"
              background-color="success"
              dark
            >
              <v-tab>Endereço</v-tab>
              <v-tab>Telefone</v-tab>
              <v-tab>E-mail</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">            
              <v-tab-item>
                <endereco-pessoa ref="formEnderecos" :enderecos="formCliente.pessoa.enderecos  || []"></endereco-pessoa>
              </v-tab-item>
              <v-tab-item>
                <telefone-pessoa ref="formTelefones" :telefones="formCliente.pessoa.telefones || []"></telefone-pessoa>
              </v-tab-item>
              <v-tab-item>
                <email-pessoa ref="formEmails" :emails="formCliente.pessoa.emails  || []"></email-pessoa>
              </v-tab-item>
          </v-tabs-items>         
          </v-form>
        </v-container>
      </v-tab-item>
      <!-- FIM - TAB CADASTRO DO CLIENTE -->

      <!-- INI - TAB ARQUIVOS DO CLIENTE -->
      <v-tab-item v-if="formCliente.id"> <!-- formCliente.id -->
        <v-container>
          <!--<v-card flat :min-height="minHeightTab">
            <v-card-text class="pt-0 pb-0 mt-0 mb-0"> -->
              <arquivos-cliente ref="arquivoCliente" :pessoa_id="formCliente.pessoa.id"></arquivos-cliente>
           <!-- </v-card-text>
          </v-card> -->
        </v-container>
      </v-tab-item>
      <!-- FIM - TAB ARQUIVOS DO CLIENTE -->

    </v-tabs-items>

  </v-card>
</template>

<script>


import ArquivosCliente from './ArquivosCliente'
import {required, requiredIf, email, minLength, maxLength, numeric, helpers} from 'vuelidate/lib/validators'
import validacaoForm from '@/mixins/validacaoForm'
import utils from '@/mixins/utils'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
const { cpf, cnpj } = require('cpf-cnpj-validator');
const validaCpfCnpj = (num) => {
  if (!num) return true
  num = num.replace(/[^a-zA-Z0-9]/g, '')
  if (num.length == 11) {
    if (cpf.isValid(num)) { return true}
  } else if (num.length == 14) {
    if (cnpj.isValid(num)) { return true }
  }
  return false
}


export default {
  name: 'CadastroCliente',
  components: {
    ArquivosCliente,
    EnderecoPessoa: () => import('@/views/Comum/EnderecoPessoa.vue'),
    TelefonePessoa: () => import('@/views/Comum/TelefonePessoa.vue'),
    EmailPessoa: () => import('@/views/Comum/EmailPessoa.vue'),
    PessoaFisica: () => import('@/views/Comum/PessoaFisica.vue'),
    PessoaJuridica: () => import('@/views/Comum/PessoaJuridica.vue'),
  },
  mixins:[validacaoForm, utils],
  data () {
    return {
      minHeightTab: 250,
      loadingBuscarCpfCnpj: false,
      tab: null,
      tabPrincipal: null,
      loading: false,
      ehPessoaFisica: true,
      formCliente: {},
    }
  },
  validations: {
    formCliente: {
      pessoa: {
        nm_pessoa: {required, minLength: minLength(6), maxLength: maxLength(60), errors: [] },
        nr_cpfcnpj: {required, validaCpfCnpj, errors: []},
      }
    },
  },
  async created() {
    this.resetErros()
    this.sincronizarCliente(this.clienteSelecionado)
    this.actloadDropDownMunicipio()

  },
  mounted() {
    //console.log('Vue', this.$refs.formCliente)
  },
  methods: {
    ...mapActions({
      storeCliente: 'cliente/STORE_CLIENTE',
      actGetCpfCnpj: 'cliente/GET_CPFCNPJ',
      actloadDropDownMunicipio: 'municipio/LOAD_DROPDOWN',
    }),
    ...mapGetters({
      getErros: 'cliente/GET_ERROS',
    }),
    ...mapMutations({
      clienteSelected: 'cliente/CLIENTE_SELECTED',
      resetErros: 'cliente/ERASE_ERROS',
      commitErro: 'cliente/SET_ERROS'
    }),
    async buscaClientePorCpfCnpj(cpfcnpj) {
      if (cpfcnpj.length < 14) return
      this.loadingBuscarCpfCnpj = true
      await this.actGetCpfCnpj(cpfcnpj)
      this.loadingBuscarCpfCnpj = false
    },
    sincronizarCliente (cliente) {
      /*this.formCliente = Object.assign(
        {}, 
        cliente
      )*/
      this.formCliente = JSON.parse(JSON.stringify(cliente))
      if (this.formCliente.pessoa.tp_pessoa === '')  this.formCliente.pessoa.tp_pessoa = 'Fisica'
    },
    converteDataToApi(data) {
      if (!data) return null
      let dtTeste = String(data)
      dtTeste = dtTeste.replace(/[^ -zA-Z0-9]/g, '');
      if (data.length === 10) {
        let dataformatado =  this.$moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
        var dateObj = new Date(dataformatado);
        var momentObj = this.$moment(dateObj);
        data = dataformatado
      }
      return data
    },
    async selecionar() {
      try {
        if (!this.formCliente.id) return { status: false }  
        return {status: true, value: this.formCliente.id, text: this.formCliente.pessoa.nm_pessoa}
      } catch (error) {
      }      
    },
    async gravarComRetorno() {
      try {
        if (!await this.gravar()) return {status: false}
        let ret = {status: true, value: this.formCliente.id, text: this.formCliente.pessoa.nm_pessoa}
        return ret
      } catch (error) {
      }      
    },
    validaAlteracao(event) {
      this.$nextTick(() => {
        let nomeForm = this.formCliente.pessoa.nm_pessoa 
        let nomeStore = this.clienteSelecionado.pessoa.nm_pessoa
        if (nomeStore != "" && nomeStore !== nomeForm) {
          this.$dialog.confirm("Você tem certeza que deseja alterar o nome do cliente?", {loader: true, okText: 'Sim', cancelText: 'Não',})
          .then(dialog => {
            this.clienteSelecionado.pessoa.nm_pessoa = this.formCliente.pessoa.nm_pessoa
            dialog.close();
          })
          .catch((e) => {
            this.formCliente.pessoa.nm_pessoa = this.clienteSelecionado.pessoa.nm_pessoa
          })
        }
      })
      event.preventDefault()
    },
    async gravar () {
      this.loading = true
      if (!(await this.validaForm())) {
        this.loading = false
        return false
      }
      if (this.$refs.formPessoaFisica) {
        if (!await this.$refs.formPessoaFisica.validaForm()) {
          this.loading = false
          return false
        }
        let objPessoaFisica = await this.$refs.formPessoaFisica.gravar()
        this.formCliente.pessoa.pessoa_fisica = objPessoaFisica
      }
      if (this.$refs.formPessoaJuridica) {
        if (!await this.$refs.formPessoaJuridica.validaForm()) {
          this.loading = false
          return false
        }
        let objPessoaJuridica = await this.$refs.formPessoaJuridica.gravar()
        this.formCliente.pessoa.pessoa_juridica = objPessoaJuridica
      }
      if (this.$refs.formEnderecos) {
        if (!await this.$refs.formEnderecos.validaForm()) {
          this.loading = false
          return false
        }
        let objEndereco = await this.$refs.formEnderecos.gravar()
        this.formCliente.pessoa.enderecos = objEndereco
      }
      if (this.$refs.formTelefones) {
        if (!await this.$refs.formTelefones.validaForm()) {
          this.loading = false
          return false
        }
        let objTelefone = await this.$refs.formTelefones.gravar()
        this.formCliente.pessoa.telefones = objTelefone
      }
      if (this.$refs.formEmails) {
        if (!await this.$refs.formEmails.validaForm()) {
          this.loading = false
          return false
        }
        let objEmail = await this.$refs.formEmails.gravar()
        this.formCliente.pessoa.emails = objEmail
      }
      if (this.formCliente.id && this.$refs.arquivoCliente) {
        if (!this.$refs.arquivoCliente.gravarDescricao()) {
          this.loading = false
          return false
        }
      }
      if (!(await this.store())) {
        this.$toaster.error('Erro ao gravar!');
        return false
      }
      this.$toaster.success('Gravação efetuada com sucesso!');
      //this.$emit('close')
      return true
    },
    async validaForm () {
      this.$v.formCliente.$touch();
      if (!this.$v.formCliente.$invalid) {
        return true
      } else if (this.$v.formCliente.$anyError) {
        return false
      }
    },
    async store () {
      try {
        var cliente = JSON.parse(JSON.stringify(this.formCliente))
        var dataNascto = cliente.pessoa.pessoa_fisica.dt_nascimento

        try {
          dataNascto = this.converteDataToApi(dataNascto)
        } catch(e) {
          this.commitErro({erros: "Erro ao converter data de nascimento em 'store'" })
          this.loading = false
          return false
        }

        cliente.pessoa.pessoa_fisica.dt_nascimento = dataNascto
        var sucess = false

        try {
          await this.storeCliente(cliente)
        } catch (e) {
          console.log(e)
          this.commitErro({erros: "Erro ao enviar dados para Api 'store'" })
          return false
        }

        if (!this.erros) sucess = true
        return sucess

      } catch(e) {
        this.commitErro({erros: "Erro não tratado em 'store'" })
        console.log(e)
        return false

      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    clienteSelecionado(novo, antigo) {
      this.sincronizarCliente(novo)
    },
    erros(novo, antigo) {
      return novo
    },
    descEnderecoExpansor (newValue, oldValue) {
      return newValue
    } 
  },
  computed: {
    ...mapState('cliente', [
      'clienteSelecionado',
      'erros',
    ]),
  },
}
</script>

<style scoped>
  .v-btn {
    padding: 0 !important;
  }
  
</style>


// WEBPACK FOOTER //
// src/views/Cliente/CadastroCliente.vue